module.exports = __webpack_public_path__ + "static/img/s5.4528135.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/an/s5.png
// module id = bgob
// module chunks = 1